import React from 'react';
import { ICONS } from 'src/common/constants';
import Button from '../../Button';
import Col from '../../Col';
import Diagnosis from '../../Diagnosis/Diagnosis';
import ServiceRequestFormDialog from '../ServiceRequestFormDialog';
import FontAwesomeIcon from '../../Icon';
import Row from '../../Row';
import Tile from '../../Tile';
import Progress from 'src/components/ServiceRequestForm/Progress/Progress';
import {
  IssueTypeOption,
  useServiceRequestFormIssueTypeOrchestrator,
  UseServiceRequestFormIssueTypeOrchestratorReturn,
} from './useServiceRequestFormIssueTypeOrchestrator';
import './ServiceRequestFormIssueType.scss';

const ServiceRequestFormIssueType = () => {
  const {
    diagnosisAsset,
    diagnosisIssueType,
    warrantyExpiresAt,
    visibleIssueTypes,
    selectedIssueTypeName,
    showIssueTypePrompt,
    nextButtonLabel,
    canProceed,
    onSelectIssueType,
    onNext,
    onBack,
    onExit,
  }: UseServiceRequestFormIssueTypeOrchestratorReturn =
    useServiceRequestFormIssueTypeOrchestrator();

  return (
    <ServiceRequestFormDialog
      title="Let's Identify the Issue"
      description="Tell us what's happening and we'll  be able to find the right solution to get your home back to normal."
      onBack={onBack}
      onExit={onExit}
      footer={
        showIssueTypePrompt ? (
          <>
            Please select issue type !
            <br />
            <br />
          </>
        ) : (
          <Button
            color="teal"
            size="small"
            label={nextButtonLabel}
            onClick={onNext}
            disabled={!canProceed}
          />
        )
      }
    >
      <Diagnosis
        asset={diagnosisAsset}
        issueType={diagnosisIssueType}
        expiresAt={warrantyExpiresAt}
      />
      <Progress currentStep={1} totalSteps={3} />
      <Row granola>
        {visibleIssueTypes.map((type: IssueTypeOption) => (
          <Col granola key={type.name} xs="6" md="4">
            <Tile
              icon={<FontAwesomeIcon weight="light" glyph={ICONS[type.name]} />}
              active={type.name === selectedIssueTypeName}
              onClick={() => onSelectIssueType(type)}
              title={type.title}
              size="tiny"
            />
          </Col>
        ))}
      </Row>
    </ServiceRequestFormDialog>
  );
};

export default ServiceRequestFormIssueType;